(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-scroll-stack-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('section-{{ section.id }}');
  if (!section) return;

  var videos = section.querySelectorAll('video[autoplay]');
  if (!videos.length) return;

  /* Pause all autoplay videos initially — let observer handle playback */
  videos.forEach(function (v) { v.pause(); });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.play().catch(function () {
            /* Autoplay blocked — silently ignore */
          });
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  videos.forEach(function (video) {
    var slide = video.closest('.scroll-stack-banner__slide');
    if (slide) observer.observe(slide);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
